import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { COOKIES_ACCEPT } from '../../constants/actions';
import classnames from 'classnames';
import { Link } from 'react-router';
import { genericRoute } from '../../routes';
import './cookie-notice.scss';

const COOKIE_DURATION = 365;
const COOKIE_NAME = 'cookies_accepted';

class Notice extends Component {
	static propTypes = {
		cookie: PropTypes.shape({ cookiesAccepted: PropTypes.bool.isRequired, showNotice: PropTypes.bool.isRequired }).isRequired,
		dispatch: PropTypes.func.isRequired,
	};

	render() {
		if (this.props.cookie.cookiesAccepted) return null;
		const classNames = classnames({
			span14: true,
			'cookie-notice': true,
			'cookie-notice--hidden': !this.props.cookie.showNotice,
		});
		return (
			<div className={classNames}>
				<p>This website uses cookies to ensure you get the best experience on our website. <Link to={genericRoute(false, 'cookie-policy')} target='_blank'>Learn&nbsp;more</Link></p>
				<button onClick={this.accept}>
					Accept cookies
				</button>
			</div>
		);
	}

	accept = () => {
		const date = new Date();
		date.setTime(date.getTime() + (COOKIE_DURATION * 24 * 60 * 60 * 1000));
		const expires = `; expires=${date.toGMTString()}`;
		document.cookie = `${COOKIE_NAME}=true${expires}; path=/`;
		this.props.dispatch({ type: COOKIES_ACCEPT });
	}
}




export default connect((state) => ({ cookie: state.cookie, dispatch: state.dispatch }))(Notice);



/** WEBPACK FOOTER **
 ** ./frontend/containers/cookie/notice.js
 **/